import { Node, Edge, getIncomers } from "@xyflow/react";

/** This helps us create the correct new edges when there are multiple nodes being deleted via multi-select */
export default function getFarthestNonDeletedIncomers(
  node: Node,
  nodes: Node[],
  edges: Edge[],
  nodesDeletedIds: string[],
): Node[] {
  const incomers = getIncomers(node, nodes, edges);

  const areAllIncomersDeleted = incomers.every((incomer) =>
    nodesDeletedIds.includes(incomer.id),
  );

  if (areAllIncomersDeleted) {
    // If all incomers are deleted, look at the incomers' incomers
    const farthestIncomers = [];
    for (const incomer of incomers) {
      // Get the incomers of the deleted incomer
      const nextLevelIncomers = getFarthestNonDeletedIncomers(
        incomer,
        nodes,
        edges,
        nodesDeletedIds,
      );
      farthestIncomers.push(...nextLevelIncomers);
    }
    return farthestIncomers;
  } else {
    return incomers;
  }
}
